import React from "react";

export const HomeNew = React.lazy(
  () => import("@/features/home-new/pages/HomeNewPage.tsx"),
);
